import React, { Component } from 'react';
import { delay } from 'lodash';
import PropTypes from 'prop-types';
import ordinal from 'ordinal-js';
import gradient from 'random-gradient';
import tinyGradient from 'tinygradient';
import tinycolor from 'tinycolor2';
import initials from 'initials';
import NumberDisplay from '../../../../components/number-display';

import styles from './styles.css';

const initialsInNamePattern = /\(([^)]+)\)/;

function loadImage(url) {
  if (!url) {
    return Promise.resolve(null);
  }
  const p = new Promise((resolve) => {
    const realUrl = url;
    if (typeof window !== 'undefined') {
      const image = new window.Image();
      image.onload = () => {
        resolve(realUrl);
      };
      image.onerror = () => {
        resolve(null);
      };
      delay(() => {
        resolve(null);
      }, 3000); // timeout
      image.src = realUrl;
    } else {
      resolve(realUrl);
    }
  });
  return p;
}


class OwnerCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      url: null,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.loadImage(this.props.owner);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.owner.full_photo_url && this.props.owner.full_photo_url !== nextProps.owner.full_photo_url) {
      this.loadImage(nextProps.owner);
    }
  }


  getPallete() {
    const { owner } = this.props;
    const id = owner.user_id;
    const bg = gradient(id); // linear-gradient(to top right, #f9e806, #06f9e8)
    const parts = bg.split(', ');
    const primaryColor = parts.length === 3 ? parts[1] : null;
    const secondaryColor = parts.length === 3 ? parts[2].replace(')', '') : null;
    return [primaryColor, secondaryColor];
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.requestShowDeals(this.props.owner.dealWithFeedbackRequestIds);
  }

  loadImage(owner) {
    loadImage(owner.full_photo_url)
      .then(
        (url) => {
          this.setState({ url, loaded: true });
        },
        () => {
          this.setState({ url: null, loaded: true });
        },
      );
  }

  renderRank() {
    const { owner: { rank } } = this.props;
    let label = <span>{rank}<sup>{ordinal.ordinalSuffix(rank)}</sup> Place Leader</span>;
    if (rank === 1) {
      label = 'Gold Leader';
    } else if (rank === 2) {
      label = 'Silver Leader';
    } else if (rank === 3) {
      label = 'Bronze Leader';
    }
    return (
      <h3 className={styles.ownerRank}>{label}</h3>
    );
  }

  renderMedal() {
    const { owner: { rank } } = this.props;
    if (rank < 1 || rank > 3) {
      return null;
    }
    let type = '';
    if (rank === 1) {
      type = 'Gold';
    } else if (rank === 2) {
      type = 'Silver';
    } else if (rank === 3) {
      type = 'Bronze';
    }
    return (
      <div className={`${styles.medalContainer} animated fadeIn pull-left`}>
        <span className={`animated bounceIn ${styles.medal} ${styles[`medal${type}`]}`}><i /></span>
      </div>
    );
  }

  render() {
    const { owner } = this.props;
    const { url, loaded } = this.state;
    const pallete = this.getPallete();

    const color = pallete[1];
    const color2 = pallete[0];
    

    const white = '#ffffff';

    const gc = tinyGradient(tinycolor.mix(color, white, 80).toHexString(), tinycolor.mix(color, white, 70).toHexString());

    /*
    const shadows = [
      `-0.0075em 0.0075em 0 ${tinycolor.mix(color2, white, 94).toHexString()}`,
      `0.005em 0.005em 0 ${tinycolor.mix(color2, white, 60).toHexString()}`,
      `0.01em 0.01em 0 ${tinycolor.mix(color2, white, 62).toHexString()}`,
      `0.015em 0.015em 0 ${tinycolor.mix(color2, white, 64).toHexString()}`,
      `0.02em 0.02em 0 ${tinycolor.mix(color2, white, 66).toHexString()}`,
      `0.025em 0.025em 0 ${tinycolor.mix(color2, white, 68).toHexString()}`,
      `0.03em 0.03em 0 ${tinycolor.mix(color2, white, 70).toHexString()}`,
      `0.035em 0.035em 0 ${tinycolor.mix(color2, white, 72).toHexString()}`,
    ];
    */

    const sty = {
      backgroundColor: tinycolor.mix(color, white, 82).toHexString(),
    };
    const innerStyles = {};

    if (url && loaded) {
      sty.backgroundImage = `url(${url})`;
      innerStyles.display = 'none';
    } else {
      sty.background = gc.css('linear', 'to bottom right');
      innerStyles.color = tinycolor.mix(color2, white, 60).toHexString();
      // innerStyles.textShadow = shadows.join(',');
    }

    const name = initials((owner.name || '').replace(initialsInNamePattern, ''));
    let dealWithFeedbackCount = (<NumberDisplay value={owner.dealWithFeedbackRequests} suffix="deal" suffixIsUnit precision={0} />);
    if (owner.dealWithFeedbackRequestIds && owner.dealWithFeedbackRequestIds.length > 0) {
      dealWithFeedbackCount = (<a href="" onClick={this.handleClick}>{dealWithFeedbackCount}</a>);
    }
    const totalDeals = (<NumberDisplay value={owner.dealCount} suffix="deal" suffixIsUnit precision={0} />);
    
    const percentage = (<NumberDisplay value={(owner.requestedFeedbackPercent * 100)} suffix="%" precision={0} />);
    return (
      <div className={`${styles.cell} animated fadeIn flipInX`}>
        <div className={styles.cellInner}>
          <div className={styles.cellUpper}>
            <div className={styles.cellPercentage}><span className="label label-default">{percentage}</span></div>
            <div className={styles.cellPhoto} style={sty}>
              <div className={styles.initial}><div style={innerStyles}>{name}</div></div>
            </div>
          </div>

          <div className={styles.cellLower}>
            <div className="clearfix">
              {this.renderMedal()}
              <div className={styles.ownerInfo}>
                <h2 className={styles.ownerName}>{owner.name}</h2>
                {this.renderRank()}
              </div>
            </div>
            <hr />
            <div>
              Asked <strong><NumberDisplay value={owner.feedbackRequestsContacts} suffix="contact" suffixIsUnit precision={0} /></strong> for feedback
              in <strong>{dealWithFeedbackCount}</strong> of <strong>{totalDeals}</strong>.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OwnerCell.propTypes = {
  owner: PropTypes.shape({
    full_photo_url: PropTypes.string,
    dealWithFeedbackRequestIds: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  requestShowDeals: PropTypes.func,
};

OwnerCell.defaultProps = {
  requestShowDeals: () => {},
};

export default OwnerCell;
